import GenericInputGroup from './generic-input-group';

export default GenericInputGroup;